// extracted by mini-css-extract-plugin
export var fadePop = "Sponsors-module--fade-pop--8506c";
export var growHeightIn = "Sponsors-module--grow-height-in--bad05";
export var imageWrapper = "Sponsors-module--imageWrapper--342c3";
export var link = "Sponsors-module--link--f6ce9";
export var sponsor = "Sponsors-module--sponsor--44b89";
export var sponsorsList = "Sponsors-module--sponsorsList--10ef1";